import { render, staticRenderFns } from "./AppCMain.vue?vue&type=template&id=587c1124&scoped=true&"
import script from "./AppCMain.vue?vue&type=script&lang=js&"
export * from "./AppCMain.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AppCMain.vue?vue&type=style&index=0&id=587c1124&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "587c1124",
  null
  ,true
)

export default component.exports